import axios from "axios";

export default {
  namespaced: true,
  state: {
    promotions: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    promotionsMessage: ''
  },
  mutations: {
    RECEIVED_PROMOTIONS(state, payload) {
      state.promotions = payload;
      state.isReceiving = false;
    },
    RECEIVING_PROMOTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_PROMOTION(state, payload) {
      state = Object.assign(state, {
        promotions: [...state.promotions, payload],
        isReceiving: false,
      })
    },
    UPDATED_PROMOTIONS(state, payload) {
      let index = state.promotions.findIndex(promotion => promotion._id === payload._id);
      state = Object.assign(state, {
        promotions: state.promotions.map((promotion, i) => {
          if (i === index) {
            return Object.assign({}, promotion, payload);
          }
          return promotion;
        }),
        isUpdating: false,
        promotionsMessage: 'Promotions has been updating!',
      })
    },
    UPDATING_PROMOTIONS(state) {
      state.isUpdating = true;
    },
    DELETED_PROMOTIONS(state, payload) {
      let indexToDelete = state.promotions.findIndex(promotion => promotion._id === payload._id);
      let promotions = [...state.promotions];
      promotions.splice(indexToDelete, 1);
      state = Object.assign(state, {
        promotions: [...promotions],
        isDeleting: false,
        idToDelete: null,
        promotionsMessage: 'Promotion has been Deleted!',
      });
    },
    DELETING_PROMOTIONS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deletePromotionRequest({dispatch}, payload) {
      dispatch("deletingPromotion", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/promotion/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        dispatch("deletePromotion", response.data);
      })
      .catch(function (error) {
        this.alertmessage = error;
      });
    },
    async deletePromotionBundleRequest({dispatch}, payload) {
      try{
        dispatch("deletingPromotion", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/promotionbundle/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deletePromotion", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deletePromotionDiscountRequest({dispatch}, payload) {
      try{
        dispatch("deletingPromotion", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/promotiondiscount/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deletePromotion", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deletePromotionDetailRequest({dispatch}, payload) {
      try{
        dispatch("deletingPromotion", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/promotiondetail/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deletePromotion", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getPromotionsRequest({dispatch}) {
      dispatch("receivingPromotions");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/promotions';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receivePromotions", res.data);
      })
    },
    async insertPromotionRequest({dispatch}, payload) {
      dispatch("receivingPromotion");
      let  token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/promotion';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receivePromotion", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertPromotionBundleRequest({dispatch}, payload) {
      try{
        dispatch("receivingPromotion");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/promotionbundle/' + payload.promotionid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(error){
        this.alertmessage = error
        return null;
      }
    },
    async insertPromotionDiscountRequest({dispatch}, payload) {
      try{
        dispatch("receivingPromotion");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/promotiondiscount/' + payload.promotionid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(error){
        this.alertmessage = error
        return null;
      }
    },
    async insertPromotionDetailRequest({dispatch}, payload) {
      let url;
      let data;
      try{
        dispatch("receivingItem");
        if(payload.imagefile!=null){
          url = 'https://api.accountxc.com:3100/insert/promotiondetail/withimage/' + payload.promotionid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/insert/promotiondetail/' + payload.promotionid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updatePromotionRequest({dispatch}, payload) {
      dispatch("updatingPromotion");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/promotion/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updatePromotion", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePromotionBundleRequest({dispatch}, payload) {
      try{
        dispatch("receivingPromotion");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/promotionbundle/' + payload.promotionbundleid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivePromotion", response.data);
        return response.data;
      }
      catch(error){
        this.alertmessage = error;
        return null;
      }
    },
    async updatePromotionDiscountRequest({dispatch}, payload) {
      try{
        dispatch("receivingPromotion");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/promotiondiscount/' + payload.promotiondiscountid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivePromotion", response.data);
        return response.data;
      }
      catch(error){
        this.alertmessage = error;
        return null;
      }
    },
    async updatePromotionDetailRequest({dispatch}, payload) {
      try{
        dispatch("receivingPromotion");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/promotiondetail/' + payload.promotiondetailid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivePromotion", response.data);
        return response.data;
      }
      catch(error){
        this.alertmessage = error;
        return null;
      }
    },
    updatePromotionImageRequest({dispatch}, payload) {
      dispatch("updatingPromotion");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/promotion/image/' + id;
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      let data = new FormData();

      data.append('image', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);

      axios({method: "put", url: url, headers: headers, data: data})
      .then(response => {
        console.log(response.data)
        dispatch("updatePromotion", response.data);
      })
      .catch((error) => {
        console.log(error.data)
        this.alertmessage = error.response.data.error;
      });
    },
    receivePromotions({commit}, payload) {
      commit("RECEIVED_PROMOTIONS", payload)
    },
    receivingPromotions({commit}) {
      commit("RECEIVING_PROMOTIONS")
    },
    receivePromotion({commit}, payload) {
      commit("RECEIVED_PROMOTION", payload)
    },
    receivingPromotion({commit}) {
      commit("RECEIVING_PROMOTIONS")
    },
    updatePromotion({commit}, payload) {
      commit("UPDATED_PROMOTIONS", payload)
    },
    updatingPromotion({commit}) {
      commit("UPDATING_PROMOTIONS")
    },
    deletePromotion({commit}, payload) {
      commit("DELETED_PROMOTIONS", payload)
    },
    deletingPromotion({commit}, payload) {
      commit("DELETING_PROMOTIONS", payload)
    }
  },
};
